import React from 'react'
import './aboutvision.scss'
import { useTheme } from '../../../contexts/ThemeProvider'
import { LIGHT_THEME } from '../../../utils/constants';

const AboutVision = () => {
    const { theme } = useTheme();
    return (
        <>

            <section className='vision_bg'>
                <div className="custom-container vision_main">

                    { theme != LIGHT_THEME ? <img src="/assets/about/sphere.png" alt="visionball" /> : <img src="/assets/about/sphere-light.png" alt="visionball" />}

                    <div className="vision_right">
                        <h3 className='about_common_heading'>Our Vision</h3>
                        <p className='about_p'>
                            We believe collective intelligence should be an accessible and powerful tool for everyone. Our mission is to unlock it.
                            <span>
                                By making outcome markets efficient and open, we are building a global system that rewards insight, reveals what people truly believe, and helps drive better decisions.
                            </span>
                            <span>
                                We built Rain as a permissionless protocol with AI-driven resolution to serve as the foundation for this vision. It provides a transparent and reliable framework that allows anyone to participate not just in forecasting the future, but in actively shaping it.
                            </span>
                            <span>
                                In the future, we plan to introduce "incentive markets," which will allow communities and organizations to use financial incentives to shape and build desired real-world outcomes.
                            </span>
                        </p>
                    </div>

                </div>
            </section>

        </>
    )
}

export default AboutVision